import { render, staticRenderFns } from "./claimCommentCard.vue?vue&type=template&id=19e17b83&scoped=true"
import script from "./claimCommentCard.vue?vue&type=script&lang=js"
export * from "./claimCommentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e17b83",
  null
  
)

export default component.exports